module.exports = __webpack_public_path__ + "img/category-skill-game.1b5e7541.png";